"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareAppconfig = void 0;
var _config = require("../publicAPI/config");
const prepareAppconfig = appconfig => {
  const isAppConfigPriorityDisabled = (0, _config.getFieldFromMeta)('disableLpbAppconfigPriority');
  if (isAppConfigPriorityDisabled !== 'true') return appconfig;
  const modifiedAppconfig = {
    ...appconfig,
    menu: (0, _config.getFieldFromMeta)('appFrame.menu') === 'true',
    header: (0, _config.getFieldFromMeta)('appFrame.header') === 'true',
    sitemapCache: false
  };
  return modifiedAppconfig;
};
exports.prepareAppconfig = prepareAppconfig;